import React, { forwardRef } from "react";
import accessibleDropdown from "../AccessibleDropdown/AccessibleDropdown";
import loaderImg from "../../assets/images/gifs/loaderGIF.gif";

// const StockHoldingSelection = ({
//   ariaHidden,
//   role,
//   index,
//   onKeyDown,
//   itemRefs,
//   onChange,
//   isChecked,
// }) => {
//   return (
//     <div className="selection excelSelection">
//       <input
//         aria-hidden={ariaHidden}
//         role={role}
//         className="input_checkbox cursor"
//         type="checkbox"
//         checked={isChecked}
//         onKeyDown={(e, index) => onKeyDown(e, index)}
//         ref={(el) => (itemRefs.current[index] = el)}
//         onChange={onChange}
//       />
//       <h3
//         className={
//           !isChecked
//             ? "unchecked_text cursor"
//             : "unchecked_text checked_text cursor"
//         }
//         onClick={onChange}
//       >
//         Show me only stocks I’m holding
//       </h3>
//     </div>
//   );
// };

const ExportStocksHoldingList = forwardRef(
  (
    {
      menuItems,
      itemRefs,
      isOpen,
      handleItemKeyDown,
      isChecked,
      setIsChecked,
      handleClick,
      restrictHover,
      accessibilityValues,
      status,
      popupClassName = {
        open: "",
        close: "",
        wrapperClass: "",
        containerClass: "",
      },
    },
    ref,
  ) => {
    return (
      <div
        className={`popup_menu popup_menu_hover ${isOpen ? popupClassName.open : popupClassName.close}`}
      >
        <div
          className={`extract_data_container ${popupClassName.containerClass}`}
        >
          <p className="export_data_text">Export Data</p>

          <div
            id={accessibilityValues.ariaControls}
            role={accessibilityValues.ariaHaspopup}
            aria-label={accessibilityValues.ariaLabel}
            aria-labelledby={accessibilityValues.buttonId}
            ref={ref}
            className="listitem_container"
          >
            {menuItems.map(({ type, className }, index) => {
              return type === "checkbox-selector" ? (
                <button
                  key={type}
                  className="list-data"
                  aria-hidden={!isOpen}
                  role="menuitemcheckbox"
                  aria-checked={isChecked}
                  ref={(el) => (itemRefs.current[index] = el)}
                  onKeyDown={(e) => {
                    handleItemKeyDown(e, index);
                  }}
                  onClick={() => setIsChecked((prev) => !prev)}
                >
                  <div className="selection excelSelection">
                    <input
                      aria-hidden={true}
                      role="menuitem"
                      className="input_checkbox cursor"
                      type="checkbox"
                      checked={isChecked}
                    />
                    <h3
                      className={
                        !isChecked
                          ? "unchecked_text cursor"
                          : "unchecked_text checked_text cursor"
                      }
                    >
                      Show me only stocks I’m holding
                    </h3>
                  </div>
                </button>
              ) : (
                <button
                  aria-hidden={!isOpen}
                  key={type}
                  ref={(el) => (itemRefs.current[index] = el)}
                  role="menuitem"
                  onKeyDown={(e) => handleItemKeyDown(e, index)}
                  className="list-data"
                  onClick={() => handleClick()}
                >
                  {" "}
                  <div className={className}></div> Export to Excel
                </button>
              );
            })}
          </div>
          {status === "pending" ? (
            <div className="popup_downloader">
              <img src={loaderImg} alt="img" />
            </div>
          ) : status === "fail" ? (
            <p className="error_content">Error downloading the file</p>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  },
);

export default accessibleDropdown(ExportStocksHoldingList);
